var morecount = "";
var resultcount = 0;
var search_xhr = [];
var filter_xhr = [];
var search_host = "";

$.extend({
  getParams: function(){
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
      hash = hashes[i].split('=');
      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    return vars;
  },
  getUrlVar: function(name){
    return $.getUrlVars()[name];
  }
});

$(document).ready(function() {
	$(".autocomplete-suggestions").click(function(){
		$("#quicksearch").submit();
	})
});


function getJSON(hittype, search_params, pageElement, search_xhr, page_id){

	var pagetypes = search_params["pagetypes"];
	var pagecategories = search_params["pagecategories"];
	var pagekeywords = search_params["pagekeywords"];
	var hits_per_call = search_params["hits_per_call"];
	var restart = search_params["restart"];
	var query = search_params["search_q"];
	var order = search_params["s_order"];

	if(order == undefined){
		order = "desc";
	}

	if(query == undefined){
		query = "";
	}

	if(restart == undefined){
		restart = "true";
	}

	if(hits_per_call == undefined){
		hits_per_call = 5;
	}

	if(pagetypes == undefined){
		pagetypes = "";
	}

	if(pagecategories == undefined){
		pagecategories = [];
	}

	if(pagekeywords == undefined){
		pagekeywords = [];
	}

	$(".news-pagination .btn-primary").hide();

	if(search_xhr[page_id] == undefined){
		search_xhr[page_id] == null;
	}

	if(search_xhr[page_id] && search_xhr[page_id].readyState != 4 ){
			search_xhr[page_id].abort();
		}

    var jsonUrl = "";
	morecount = parseInt($("#morenum").val(), 10);

	if(isNaN(morecount) || morecount == undefined){
		morecount = 1;
	}

	if(restart == "true"){
		morecount = 1;
		pageElement.empty();
	}

	var pagetype = pagetypes.join(',');

	if(pagetype == undefined){
		pagetype = "";
	}

	if(!Array.isArray(pagecategories)){
		pagecategories = [];
	}

	if(!Array.isArray(pagekeywords)){
		pagekeywords = [];
	}

	var pagecategory = pagecategories.join(',');
	var pagekeyword = pagekeywords.join(',');

	if(pagecategory == undefined){
		pagecategory = "";
	}

	if(pagekeyword == undefined){
		pagekeyword = "";
	}

	if(location.hostname == "localhost"){
		// Dev URL
		jsonUrl = "administration/json_suche/search_results_xml.php?search_q="+query+"&page_type="+pagetype+"&page_categories="+pagecategory+"&page_keywords="+pagekeyword+"&s_c="+hits_per_call+"&s_call="+hittype+"&s_order="+order+"&s_op=and&s="+morecount;
	}else{
		// Live DS URL
		//jsonUrl = "http://rd-11-delivery:8080/cps/rde/xchg/mitbestimmungsportal/xsl/json.xsl/-/html/search_results.html?page_type1="+pagetype1+"&page_type2="+pagetype2+"&page_type3="+pagetype3+"&s_op=and&s="+$("#morenum").val();
		jsonUrl = search_host+"/hbssearch/search_results.html?search_q="+query+"&page_type="+pagetype+"&page_categories="+pagecategory+"&page_keywords="+pagekeyword+"&s_c="+hits_per_call+"&s_call="+hittype+"&s_order="+order+"&s_op=and&s="+morecount;
	}

	search_xhr[page_id] = $.ajax({
	  url: jsonUrl,
	  cache: false,
	  async: false,
	  dataType: 'xml',
	  jsonp: false,
	  jsonpCallback: hittype,
	  success: function(data){
		var jsondata = parseXMLtoJSON(data);
		//console.log(data);
		//console.log(jsondata);

		// Zahlen für das Blättern ermitteln
		resultcount = jsondata.hits;
		//console.log(resultcount);

		var resultmorecount = (morecount*hits_per_call);
		if((morecount) == 1){
			resultmorecount = hits_per_call;
		}else if(resultmorecount >= resultcount){
			resultmorecount = resultcount;
		}
		//Ergebnisse anzeigen
		if(hittype == "Themenradar" || hittype == "news_monitor"){
			hit_themenradar(jsondata, pageElement);
			if(Object.keys(jsondata).length != 0 && resultmorecount < resultcount){
				morecount = morecount+1;
				$("#morenum").val(morecount);
				$(".news-pagination .btn-primary").show();
			}else{
				$(".news-pagination .btn-primary").hide();
			}
			if(resultcount < resultmorecount && resultcount < hits_per_call){
				resultmorecount = resultcount
			}
			$(".amount span").empty().append(resultmorecount+" von "+resultcount);

		} else if (hittype == "articleList") {
			hit_articleList(jsondata, pageElement, search_params);
		} else if (hittype == "sliderList2") {
			hit_sliderList(jsondata, pageElement, 2, search_params);
		} else if (hittype == "sliderList3") {
			hit_sliderList(jsondata, pageElement, 3, search_params);
		} else if (hittype == "sliderList2_event") {
			hit_sliderList_event(jsondata, pageElement, 2, search_params);
		} else if (hittype == "sliderList3_event") {
			hit_sliderList_event(jsondata, pageElement, 3, search_params);
		} else if (hittype == "Veranstaltungen") {
			hit_events(jsondata, pageElement);
			if(Object.keys(jsondata).length != 0 && resultmorecount < resultcount){
				morecount = morecount+1;
				$("#morenum").val(morecount);
				$(".news-pagination .btn-primary").show();
			}else{
				$(".news-pagination .btn-primary").hide();
			}
			if(resultcount < resultmorecount && resultcount < hits_per_call){
				resultmorecount = resultcount
			}
			$(".amount span").empty().append(resultmorecount+" von "+resultcount);
		} else if (hittype == "Kartenstapel") {
			hit_staple(jsondata, pageElement);
			if(Object.keys(jsondata).length != 0 && resultmorecount < resultcount){
				morecount = morecount+1;
				$("#morenum").val(morecount);
				$(".news-pagination .btn-primary").show();
			}else{
				$(".news-pagination .btn-primary").hide();
			}
			if(resultcount < resultmorecount && resultcount < hits_per_call){
				resultmorecount = resultcount
			}
			$(".amount span").empty().append(resultmorecount+" von "+resultcount);
		} else if (hittype == "OnSiteSearch") {
			hit_search(jsondata, pageElement, query);
			if(Object.keys(jsondata).length != 0 && resultmorecount < resultcount){
				morecount = morecount+1;
				$("#morenum").val(morecount);
				$(".news-pagination .btn-primary").show();
			}else{
				$(".news-pagination .btn-primary").hide();
			}
			if(resultcount < resultmorecount && resultcount < hits_per_call){
				resultmorecount = resultcount
			}
			$(".amount span").empty().append(resultmorecount+" von "+resultcount);
		}
	  },
	  error : function(httpReq,status,exception){
		console.log("Hits:"+hittype+" - "+status+" "+exception);

	  }
	});
}

function getFacet(hittype, search_params, pageElement, filter_xhr, page_id){

	var pagetypes = search_params["pagetypes"];
	var pagecategories = search_params["pagecategories"];
	var pagekeywords = search_params["pagekeywords"];
	var hits_per_call = search_params["hits_per_call"];
	var restart = search_params["restart"];
	var query = search_params["search_q"];

	if(query == undefined){
		query = "";
	}

	if(restart == undefined){
		restart = "true";
	}

	if(hits_per_call == undefined){
		hits_per_call = 5;
	}

	if(pagetypes == undefined){
		pagetypes = "";
	}

	if(pagecategories == undefined){
		pagecategories = "";
	}

	if(pagekeywords == undefined){
		pagekeywords = "";
	}

	if(filter_xhr[page_id] && filter_xhr[page_id].readyState != 4 ){
			filter_xhr[page_id].abort();
		}


    var jsonUrl = "";
	var pagetype = pagetypes.join(',');

	if(pagetype == undefined){
		pagetype = "";
	}

		if(!Array.isArray(pagecategories)){
		pagecategories = [];
	}

	if(!Array.isArray(pagekeywords)){
		pagekeywords = [];
	}

	var pagecategory = pagecategories.join(',');
	var pagekeyword = pagekeywords.join(',');

	if(pagecategory == undefined){
		pagecategory = "";
	}

	if(pagekeyword == undefined){
		pagekeyword = "";
	}

	if(location.hostname == "localhost"){
		// Dev URL
		jsonUrl = "administration/json_suche/search_xml_facet.php?search_q="+query+"&page_type="+pagetype+"&page_categories="+pagecategory+"&page_keywords="+pagekeyword+"&s_call="+hittype+"&s_op=and&s=1";
	}else{
		// Live DS URL
		jsonUrl = search_host+"/hbssearch/search_facet.html?search_q="+query+"&page_type="+pagetype+"&page_categories="+pagecategory+"&page_keywords="+pagekeyword+"&s_call="+hittype+"&s_op=and&s=1";
	}

	filter_xhr[page_id] = $.ajax({
	  url: jsonUrl,
	  cache: false,
	  async: false,
	  dataType: 'xml',
	  jsonp: false,
	  jsonpCallback: hittype,
	  success: function(data){
		//Ergebnisse benutzen um den Filter zu bauen
		var jsondata = parseXMLtoJSON(data);
		if(Object.keys(jsondata).length > 1){
			facet_categories(jsondata);
		}
	  },
	  error : function(httpReq,status,exception){
		console.log("Filter:"+hittype+" - "+status+" "+exception);
	  }
	});

	$("#filter_catgoriesgroup1 input").change(function(event){

		var keyword = [];
		var theParent = $(this);

		if(!$(this).parent().hasClass("active")){
			keyword = [encodeURIComponent($(this).parent().text().trim())];
		}

		$("#filter_catgoriesgroup1 label.active").each(function(){
			if($(theParent).parent().text().trim() != $(this).text().trim()){
				keyword.push(encodeURIComponent($(this).text().trim()));
			}

		});

		restart = "true";
		search_params["pagecategories"] = keyword;
		getJSON(hittype, search_params, pageElement, filter_xhr, page_id);


	});



}

function getpageCategories(){

	var keyword = [];

	$("#filter_catgoriesgroup1 label.active").each(function(){
		keyword.push(encodeURIComponent($(this).text().trim()));
	});

	return keyword;

}

function facet_categories(facethits){

var facethits_arr = [];

$.each(facethits, function(key, val) {
	if(key != "hits" && key != "none" ){
		facethits_arr.push(val);
	}
});

facethits_arr = facethits_arr.sort();

var filter = '';

filter+= '<div class="filter-group" id="filter_catgories">';
filter+= '	<p><a class="btn" data-toggle="collapse" href="#filter_catgoriesgroup1" aria-expanded="true" aria-controls="filter_catgoriesgroup1">';
filter+= '	  Nach Kategorien filtern';
filter+= '	</a></p>';
filter+= '	<div class="collapse in" id="filter_catgoriesgroup1" aria-expanded="true">';
filter+= '  	<div class="btn-group" data-toggle="buttons">';

$.each(facethits_arr, function(key, val) {
		filter+= '	  	<label class="btn btn-pill">';
		val = val.replace("??ffentliche Infrastruktur","Öffentliche Infrastruktur");
		filter+= '    		<input type="checkbox" autocomplete="off">'+val;
		filter+= '		</label>';
});

filter+= '		</div>';
filter+= '	</div>';
filter+= '</div>';


$(".filter").append(filter);
}


function hit_themenradar(searchhits, pageElement){

	var hit = '';

	$.each(searchhits, function(key, val) {
		if(key != "hits" && key != "none"){
			var changeddate = val.page_lastChanged_date;
			if(!/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/.test(changeddate)){
				var date = new Date(changeddate.replace("CEST ",""));
				if(/CET/.test(changeddate)){
					date = new Date(changeddate.replace("CET ",""));
				}
				var day = date.getDate();
				var month = date.getMonth()+1;
				var year = date.getFullYear();

				if(month <10 ){
					month = "0"+month;
				}
				if(day <10 ){
					day = "0"+day;
				}

				changeddate = day+"."+month+"."+year;
			}

			hit = '<!-- Themenradar Hit -->';
			if(val.page_highlight_str == "1"){
				hit+= '<article class="news-item featured">';
			}else{
				hit+= '<article class="news-item">';
			}



			if(val.page_img_teaser_str.length > 1){
				hit+= '	<figure class="figure">';
				hit+= '		<a href="'+val.page_url_str+'"><img src="'+val.page_img_teaser_str+'" alt="'+val.page_img_teaser_copyright_str+'"></a>';
				hit+= '	</figure>';
			}

			hit+= '	<p class="subtitle">';
        if(val.page_new_str == "Ja"){
				  hit+= '<span class="tag-label tag-label-new">Link</span>';
			  }
        if(val.page_updated_str == "Update"){
          hit+= '<span class="tag-label">Aktualisiert</span>';
        }
      hit+= '<time>'+changeddate+'</time><span>'+val.page_kicker_str+'</span></p>';
			hit+= '	<h3 class="title"><a href="'+val.page_url_str+'">'+val.page_title_str+'</a></h3>';
			hit+= '	<p class="intro">'+val.page_teaser_text_str+'&nbsp;<span class="readmore"><a href="'+val.page_url_str+'">mehr</a></span></p>';
			hit+= '</article>';
			hit+= '<!-- /Themenradar Hit -->';
			pageElement.append(hit);
		}
	});

}

function hit_events(searchhits, pageElement){

	var hit = '';

	$.each(searchhits, function(key, val) {
		if(key != "hits" && key != "none" ){
			var changeddate = val.page_lastChanged_date;
			if(!/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/.test(changeddate)){
				var date = new Date(changeddate.replace("CEST ",""));
				if(/CET/.test(changeddate)){
					date = new Date(changeddate.replace("CET ",""));
				}
				var day = date.getDate();
				var month = date.getMonth()+1;
				var year = date.getFullYear();

				if(month <10 ){
					month = "0"+month;
				}
				if(day <10 ){
					day = "0"+day;
				}

				changeddate = day+"."+month+"."+year;
			}

			hit = '<!-- Veranstaltung Hit -->';
			if(val.page_highlight_str == "1"){
				hit+= '<article class="events-item featured">';
			}else{
				hit+= '<article class="events-item">';
			}



			if(val.page_img_teaser_str.length > 1){
				hit+= '	<figure class="figure">';
				hit+= '		<a href="'+val.page_url_str+'"><img src="'+val.page_img_teaser_str+'" alt="Bildbeschreibung"></a>';
				hit+= '	</figure>';
			}

			hit+= '	<p class="subtitle title-red"">'+val.page_kicker_str+'</p>';
			hit+= '	<h3 class="title"><a href="'+val.page_url_str+'">'+val.page_title_str+'</a></h3>';
			hit+= '	<p class="date">'+val.page_event_start_str;

			if(val.page_event_end_str.length >1  && val.page_event_end_str != undefined && val.page_event_start_str.split(" ")[0] != val.page_event_end_str.split(" ")[0]){
				hit+= '	bis '+val.page_event_end_str+'</p>';
			}else{
				hit+= '</p>';
			}


			if(val.page_event_location_str.length >1 && val.page_event_location_str != undefined && val.page_event_city_str.length >1 && val.page_event_city_str != undefined){
				hit+= '	<p class="subtitle">'+val.page_event_location_str+', '+val.page_event_city_str+'</p>';
			}else if(val.page_event_city_str.length >1 && val.page_event_city_str != undefined){
				hit+= '	<p class="subtitle">'+val.page_event_city_str+'</p>';
			}else if(val.page_event_location_str.length >1 && val.page_event_location_str != undefined){
				hit+= '	<p class="subtitle">'+val.page_event_location_str+'</p>';
			}else{
				//Keine Location
			}

			hit+= '	<p class="intro">'+val.page_teaser_text_str+'&nbsp;<span class="readmore"><a href="'+val.page_url_str+'">mehr</a></span></p>';
			hit+= '</article>';
			hit+= '<!-- /Veranstaltung Hit -->';
			pageElement.append(hit);
		}
	});

}

function hit_articleList(searchhits, pageElement, search_params) {

	var hit = '';

	$.each(searchhits, function(key, val) {
		if(key != "hits" && key != "none" ){
			var changeddate = val.page_lastChanged_date;
			if(!/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/.test(changeddate)){
				var date = new Date(changeddate.replace("CEST ",""));
				if(/CET/.test(changeddate)){
					date = new Date(changeddate.replace("CET ",""));
				}
				var day = date.getDate();
				var month = date.getMonth()+1;
				var year = date.getFullYear();

				if(month <10 ){
					month = "0"+month;
				}
				if(day <10 ){
					day = "0"+day;
				}

				changeddate = day+"."+month+"."+year;
			}

			hit = '<!-- Article List Hit -->';
			if(val.page_highlight_str == "1"){
				hit+= '<article class="clearfix featured">';
			}else{
				hit+= '<article class="clearfix">';
			}

			if(val.page_img_teaser_str.length > 1){
				hit+= '	<figure class="figure">';
				hit+= '		<a href="'+val.page_url_str+'"><img src="'+val.page_img_teaser_str+'" alt="Bildbeschreibung"></a>';
				hit+= '	</figure>';
			}

			hit+= '	<p class="subtitle"><time>'+changeddate+'</time><span>'+val.page_kicker_str+'</span></p>';
			hit+= '	<h3 class="title"><a href="'+val.page_url_str+'">'+val.page_title_str+'</a></h3>';
			if(search_params["ohneTeaser"] != "ja"){
				hit+= '	<p class="intro">'+val.page_teaser_text_str+'&nbsp;<span class="readmore"><a href="'+val.page_url_str+'">mehr</a></span></p>';
			}
			hit+= '</article>';
			hit+= '<!-- /Article List Hit -->';

			pageElement.append(hit);
		}
	});
}

function hit_sliderList(searchhits, pageElement, hitcount, search_params) {

	var hit = '';

	$.each(searchhits, function(key, val) {
		if(key != "hits" && key != "none" ){
			var changeddate = val.page_lastChanged_date;
			if(!/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/.test(changeddate)){
				var date = new Date(changeddate.replace("CEST ",""));
				if(/CET/.test(changeddate)){
					date = new Date(changeddate.replace("CET ",""));
				}
				var day = date.getDate();
				var month = date.getMonth()+1;
				var year = date.getFullYear();

				if(month <10 ){
					month = "0"+month;
				}
				if(day <10 ){
					day = "0"+day;
				}

				changeddate = day+"."+month+"."+year;

			}

			hit = '<!-- Slider List Hit -->';
			hit+= '<li><div class="slide-list-item">	';
			hit+= '<p class="date">'+changeddate+'</p>';
			hit+= '<p class="subtitle">'+val.page_kicker_str+'</p>';
			hit+= '<h2 class="title"><a href="'+val.page_url_str+'">'+val.page_title_str+'</a></h2>';
			if(search_params["ohneTeaser"] != "ja"){
				hit+= '<p class="intro">'+val.page_teaser_text_str+'&nbsp;<span class="readmore"><a href="'+val.page_url_str+'">mehr</a></span></p>';
			}
			hit+= '</div></li>';
			hit+= '<!-- /Slider List Hit -->';

			pageElement.append(hit);
		}
	});

	initSlider();

}

function hit_sliderList_event(searchhits, pageElement, hitcount, search_params) {

	var hit = '';

	$.each(searchhits, function(key, val) {
		if(key != "hits" && key != "none" ){
			var changeddate_start = val.page_event_start_str;
			if(!/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/.test(changeddate_start)){
				var date = new Date(changeddate_start.replace("CEST ",""));
				if(/CET/.test(changeddate_start)){
					date = new Date(changeddate_start.replace("CET ",""));
				}
				var day = date.getDate();
				var month = date.getMonth()+1;
				var year = date.getFullYear();

				if(month <10 ){
					month = "0"+month;
				}
				if(day <10 ){
					day = "0"+day;
				}

				changeddate_start = day+"."+month+"."+year;

			}

			var changeddate_ende = val.page_event_end_str;
			if(!/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/.test(changeddate_ende)){
				var date = new Date(changeddate_ende.replace("CEST ",""));
				if(/CET/.test(changeddate_ende)){
					date = new Date(changeddate_ende.replace("CET ",""));
				}
				var day = date.getDate();
				var month = date.getMonth()+1;
				var year = date.getFullYear();

				if(month <10 ){
					month = "0"+month;
				}
				if(day <10 ){
					day = "0"+day;
				}

				if($.isNumeric(day) && $.isNumeric(month) && $.isNumeric(year)){
					changeddate_ende = day+"."+month+"."+year;
				}
			}

			if(changeddate_ende.length > 1 && changeddate_ende != undefined && changeddate_start != changeddate_ende){
				changeddate_ende = " bis "+changeddate_ende;
			}else{
				changeddate_ende = "";
			}

			hit = '<!-- Slider List Hit -->';
			hit+= '<li><div class="slide-list-item">	';
			hit+= '<p class="date">'+changeddate_start+changeddate_ende+'</p>';
			hit+= '<p class="subtitle">'+val.page_kicker_str+'</p>';
			var title_string = val.page_title_str;
			if(title_string.length >45){
				title_string = title_string.substring(0,45);
				title_string+= " &hellip;";
			}

			hit+= '<h2 class="title"><a href="'+val.page_url_str+'">'+title_string+'</a></h2>';
			if(search_params["ohneTeaser"] != "ja"){
				hit+= '<p class="intro">'+val.page_teaser_text_str+'&nbsp;<span class="readmore"><a href="'+val.page_url_str+'">mehr</a></span></p>';
			}
			hit+= '</div></li>';
			hit+= '<!-- /Slider List Hit -->';

			pageElement.append(hit);
		}
	});

	initSlider();

}


function hit_staple(searchhits, pageElement) {

	var hit = '';

	$.each(searchhits, function(key, val) {
		if(key != "hits" && key != "none" ){
			var changeddate = val.page_lastChanged_date;
			if(!/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/.test(changeddate)){
				var date = new Date(changeddate.replace("CEST ",""));
				if(/CET/.test(changeddate)){
					date = new Date(changeddate.replace("CET ",""));
				}
				var day = date.getDate();
				var month = date.getMonth()+1;
				var year = date.getFullYear();

				if(month <10 ){
					month = "0"+month;
				}
				if(day <10 ){
					day = "0"+day;
				}

				changeddate = day+"."+month+"."+year;
			}

			hit = '<!-- Staple Hit -->';
			hit+= '<li>';
      hit+= '	<a class="stacks-item stacks-item-image" href="'+val.page_url_str+'" title="Gehe zu: Thema'+val.page_title_str+'">';
      hit+= '   <div class="top">';
      hit+= '     <figure>';

      if(val.page_img_teaser_str != "" && val.page_img_teaser_str != undefined){
        hit+= '       <img src="'+val.page_img_teaser_str+'" alt="'+val.page_title_str+'" />';
      }else{
        hit+= '       <img src="/design/hbs-mbp/img/blanc.png" alt="'+val.page_title_str+'" />';
      }
      hit+= '     </figure>';
 			hit+= '		  <p class="subtitle">'+val.page_kicker_str+'</p>';
      hit+= '		  <p class="title">'+val.page_title_str+'</p>';
      hit+= ' </div>';
      hit+= ' <div class="bottom">';
      hit+= '   <p class="new">';

      if(val.page_updated_str == "Update"){
        hit+= '     <span class="tag-label">Aktualisiert</span>';
      }

      hit+= '		  <span class="amount">'+val.page_card_count_str+' Themenkarten</p>';
      hit+= '   </p>';
      hit+= ' </div>';
			hit+= '	</a>';
			hit+= '</li>'
			hit+= '<!-- /Staple Hit -->';

			pageElement.append(hit);
		}
	});
}

function hit_search(searchhits, pageElement, searchstring) {

	var hit = '';

	$.each(searchhits, function(key, val) {
		if(key != "hits" && key != "none" && val.page_title_str.length > 1){
			var changeddate = val.page_lastChanged_date;
			if(!/[0-9]{2}\.[0-9]{2}\.[0-9]{4}/.test(changeddate)){
				var date = new Date(changeddate.replace("CEST ",""));
				if(/CET/.test(changeddate)){
					date = new Date(changeddate.replace("CET ",""));
				}
				var day = date.getDate();
				var month = date.getMonth()+1;
				var year = date.getFullYear();

				if(month <10 ){
					month = "0"+month;
				}
				if(day <10 ){
					day = "0"+day;
				}

				changeddate = day+"."+month+"."+year;
			}

			var highlighted_text = val.highlighting;

			//console.log(highlighted_text);

			var reg = new RegExp(searchstring, 'gi');
			if(searchstring != ""){
				highlighted_text = highlighted_text.replace(/ +(?= )/g,' ').replace(reg,function(str) {return "<strong>"+str+"</strong>"});
			}

			hit = '<!-- Search Hit -->';
			hit+= '			<article class="search-item">';
			hit+= '	            <h3 class="title"><a href="'+val.page_url_str+'">'+val.page_title_str+'</strong></a></h3>';
			hit+= '			<p class="intro">...'+highlighted_text.substring(0,300)+'...</p>';
			hit+= '	        	</article>';
			hit+= '<!-- /Search Hit -->';

			pageElement.append(hit);
		}
	});
}

function parseXMLtoJSON(xmlstr){

	//var xmlDocStr = $.parseXML( xmlstr );
	var $xmlDoc = $( xmlstr );
	//var jsonstr = "";
	var jsonstr = '{ "hits" : "'+xmlstr.getElementsByTagNameNS("*","searchresult")[0].getAttribute("hits")+'",';

	var counter = 1;
	if($xmlDoc.find("search_overview").length >0){
		$.each($xmlDoc.find("search_overview"), function(){
			jsonstr+= '"hit'+counter+'": {';
			jsonstr+= '  "page_event_end_str" : "'+htmlEscape($(this).find("page_event_end_str").text())+'",';
			jsonstr+= '  "page_intro_str" : "'+htmlEscape($(this).find("page_intro_str").text())+'",';
			jsonstr+= '  "page_teaser_text_str" : "'+htmlEscape($(this).find("page_teaser_text_str").text())+'",';
			jsonstr+= '  "page_event_city_str" : "'+htmlEscape($(this).find("page_event_city_str").text())+'",';
			jsonstr+= '  "Level_2_str" : "'+htmlEscape($(this).find("Level_2_str").text())+'",';
			jsonstr+= '  "page_title_str" : "'+htmlEscape($(this).find("page_title_str").text())+'",';
			jsonstr+= '  "page_highlight_str" : "'+htmlEscape($(this).find("page_highlight_str").text())+'",';
			jsonstr+= '  "page_kicker_str" : "'+htmlEscape($(this).find("page_kicker_str").text())+'",';
			jsonstr+= '  "title" : "'+htmlEscape($(this).find("title").text())+'",';
			jsonstr+= '  "page_card_count_str" : "'+htmlEscape($(this).find("page_card_count_str").text())+'",';
			jsonstr+= '  "page_lastChanged_date" : "'+htmlEscape($(this).find("page_lastChanged_date").text())+'",';
			jsonstr+= '  "page_author_str" : "'+htmlEscape($(this).find("page_author_str").text())+'",';
			jsonstr+= '  "page_seo_title_str" : "'+htmlEscape($(this).find("page_seo_title_str").text())+'",';
			jsonstr+= '  "page_categories_strm" : "'+htmlEscape($(this).find("page_categories_strm").text())+'",';
			jsonstr+= '  "Level_3_str" : "'+htmlEscape($(this).find("Level_3_str").text())+'",';
			jsonstr+= '  "Level_1_str" : "'+htmlEscape($(this).find("Level_1_str").text())+'",';
			jsonstr+= '  "page_event_start_str" : "'+htmlEscape($(this).find("page_event_start_str").text())+'",';
			jsonstr+= '  "page_url_str" : "'+htmlEscape($(this).find("page_url_str").text())+'",';
			jsonstr+= '  "page_keywords_strm" : "'+htmlEscape($(this).find("page_keywords_strm").text())+'",';
			jsonstr+= '  "page_img_teaser_str" : "'+htmlEscape($(this).find("page_img_teaser_str").text())+'",';
			jsonstr+= '  "page_img_teaser_copyright_str" : "'+htmlEscape($(this).find("page_img_teaser_copyright_str").text())+'",';
			jsonstr+= '  "page_img_teaser_alttext_str" : "'+htmlEscape($(this).find("page_img_teaser_alttext_str").text())+'",';
      jsonstr+= '  "page_updated_str" : "'+htmlEscape($(this).find("page_updated_str").text())+'",';
      jsonstr+= '  "page_new_str" : "'+htmlEscape($(this).find("page_new_str").text())+'",';
			jsonstr+= '  "page_type_str" : "'+htmlEscape($(this).find("page_type_str").text())+'",';
			//console.log($(this).find("highlighting"));
			//if($(this).find("highlighting").attr("mode") == "cdata"){
				jsonstr+= '  "highlighting" : "'+htmlEscape($(this).find("highlighting").text())+'",';
			//}
			jsonstr+= '  "page_description_str" : "'+htmlEscape($(this).find("page_description_str").text())+'",';
			jsonstr+= '  "page_event_location_str" : "'+htmlEscape($(this).find("page_event_location_str").text())+'",';
			jsonstr+= '  "page_id_str" : "'+htmlEscape($(this).find("page_id_str").text())+'",';
			jsonstr+= '  "Level_4_str" : "'+htmlEscape($(this).find("Level_4_str").text())+'"';
			jsonstr+= '   } ,';
			counter = counter+1;
		});
	}else if($xmlDoc.find("search_facet").length >0){
		var dublette = [];
		$.each($xmlDoc.find("category facet"), function(){
			if(htmlEscape($(this).attr("name")).length > 4){
				if(jQuery.inArray(htmlEscape($(this).attr("name")), dublette) !== -1){
					jsonstr+= '  "facet'+counter+'" : "'+htmlEscape($(this).attr("name"))+'",';
					counter = counter+1;
				}
				dublette.push(htmlEscape($(this).attr("name")));
			}
		});

	}

    jsonstr = jsonstr.replace(/^,|,$/g,'');
	jsonstr+= '  }';

	//console.log(jsonstr);

	try{
		JSON.parse(jsonstr);
	}catch(er){
		console.log(jsonstr);
		console.log(er);
	}

return JSON.parse(jsonstr);

}

function htmlEscape(str) {
    return String(str)
      .replace(/"/g, '\\"')
			.replace(/“/g, '&#x201C;')
			// .replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, "") // original
			.replace(/(\r\n|\n\r|\r|\n)/g, "") // modified, hotfix
			.replace(/\t/g, '')
			.replace(/(<([^>]+)>)/ig,"")
			.replace(/\\\(/g,"\(")
			.replace(/\\\)/g,"\)");
}
